import { AppRouteProps } from "@bsm/component";
import React from "react";
import { StudentImportRoute } from "./views/import/StudentImportRoute";
import { StudentGroupViewerRoutes } from "./views/viewer/StudentGroupViewerRoutes";

const StudentListContainer = React.lazy(() => import('./containers/StudentListContainer'))

export const StudentListRoutes: Array<AppRouteProps> = [
    {
        path: 'students',
        title: 'Bsm.StudentList.Title',
        element: <StudentListContainer />,
        roles: ['STUDENT'],
        children: [
            ...StudentImportRoute,
            ...StudentGroupViewerRoutes
        ]
    }
]